import React from 'react';
const Loading = ({children}) =>
    <div className="loading">
        {/* <div className="center">
            <i className="fa fa-spinner fa-spin"></i>
        </div> */}
        {children}
    </div>;

export default Loading;


// WEBPACK FOOTER //
// ./src/Components/search/components/Loading.jsx